import * as c from "purify-ts/Codec";
import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { Source } from "trader.ts/types/source";
import { Form, checkBox } from "trader.ts/ui.forms";
import { invoiceid } from "../../../sql/classy/types";
import * as style from "../../../styles/style.css.classes";
import { renderDownloadExampleSection } from "../../client/download_example_button";
import { fileInputField } from "../../client/fileinput";
import { renderSaveButton } from "../../client/savebutton";
import { localStorageSpec } from "../../lib/localstorage";
import { wrapInParentheses } from "../../render";
import * as routes from "../../routes";

const invoiceLS: localStorageSpec<{
  description: string;
  id: invoiceid;
}> = {
  key: "classy_school_invoice_example_id",
  codec: c.Codec.interface({
    description: c.string,
    id: c.number as unknown as c.Codec<invoiceid>,
  }),
};

export function render(opts: {
  filename: string | null;
  show_seperate_invoice_lines: boolean;
}): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("new_file", [], async () => {
      return fileInputField({
        initial: opts.filename ? { filename: opts.filename } : null,
        label:
          "Hoofding" +
          " " +
          wrapInParentheses("Resolutie: breedte 595px"),
        initiallabel: opts.filename
          ? "Upload nieuwe hoofding"
          : "Upload hoofding",
        selectedlabel: "Geselecteerd",
      });
    })
    .addField("show_seperate_invoice_lines", [], () =>
      checkBox({
        initialVal: opts.show_seperate_invoice_lines,
        label: "Toon aparte factuurlijnen op factuur",
        class: style.input_like + style.checkbox,
      }),
    )
    .build({
      render: (fields) => (
        <div>
          {fields.new_file()}
          <label for="">{"Factuurlijnen"}</label>
          {fields.show_seperate_invoice_lines()}
        </div>
      ),
    });

  const showDownloadExamplePopupS = new Source(false);

  return (
    <div>
      <section className={style.cancel_main_margins}>
        {"Personaliseer hier hoe de PDF van een factuur er uit ziet."}
      </section>

      <section className={style.equal_columns}>
        <div>{form.render()}</div>

        <div>
          <label for="">{"Voorbeeld"}</label>
          {renderDownloadExampleSection({
            findOptions: ({ searchstring }) =>
              rpc(routes.searchInvoicesSpec, undefined, { searchstring }),
            showOption: (t) => t.description,
            makeDownloadLink: (t) =>
              routes.downloadInvoicePdfSpec.route.link({
                invoiceid: t.id,
              }),
            inputLabel: "Zoek factuur op factuurnummer",
            lsSpec: invoiceLS,
            close: () => showDownloadExamplePopupS.set(false),
          })}
        </div>
      </section>

      <div style="display: flex;">
        <div style="flex: 1"></div>

        <div>
          {renderSaveButton({
            formS: form.s,
            save: (v) => {
              return rpc(routes.saveInvoicePdfConfigSpec, undefined, {
                show_seperate_invoice_lines: v.show_seperate_invoice_lines,
                header_new_file: v.new_file,
              });
            },
            reload: true,
          })}
        </div>
      </div>
    </div>
  );
}
